// @ts-strict-ignore
import React from 'react';
import clsx from 'clsx';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { SvgIconReact } from 'common/components/svg-icon';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { Directions } from 'common/components/drop-menu/types';
import { TooltipAttrs } from 'common/components/tooltip/types';
import { SectionItem } from 'common/components/items-menu/types';
import { ResourceType } from 'common/report/constants';
import { MetricType } from 'common/types/reports/bookmark';
import { useTranslation } from 'common/i18n/hooks';
import { SelectorType, SelectorTypeDefinitions } from '../types';
export function AddEntryHeader(props: {
  headerRef: React.RefObject<HTMLDivElement>;
  label: string;
  isAddingDisabled: boolean;
  reportName: string;
  disableAddEntry: boolean;
  isSelectDisabled: boolean;
  rowLimit: number;
  canDrop: boolean;
  canAlterEntries: boolean;
  addEntryMenuWidth: number;
  numEntries: number;
  isStickyHeader: boolean;
  isTypeSelectOpen: boolean;
  draggingOverStepIndex: number;
  typeItems: SectionItem[];
  tooltipAttrs: TooltipAttrs;
  headerItems?: React.ReactNode;
  onAddTypeSelectMenuChange: (ev: CustomEvent) => void;
  onClickAdd: (type: SelectorType, typeSelect?: boolean) => void;
  onDragLeave: () => void;
  onDrop: (ev: React.DragEvent) => void;
  onDragOver: (ev: React.DragEvent) => void;
}) {
  const {
    t
  } = useTranslation();
  const singleEntryType = props.typeItems.length === 1 && props.typeItems[0].value;
  const isAddingSupported = !props.disableAddEntry && (props.rowLimit > 0 ? props.canAlterEntries : true);
  const isAddingDisabled = props.isAddingDisabled && singleEntryType !== SelectorTypeDefinitions.Metrics;
  const isSelectDisabled = props.isSelectDisabled;
  const sections = [{
    items: props.typeItems.filter(item => [ResourceType.User, ResourceType.Event].includes(item.value))
  }, {
    items: props.typeItems.filter(item => [ResourceType.Formula].includes(item.value))
  }, {
    items: props.typeItems.filter(item => [ResourceType.Cohort, MetricType.Funnel, MetricType.Retention].includes(item.value))
  }];
  return <>
      {props.canDrop && <div className='header-drop-zone drop-zone' onDragLeave={props.onDragLeave} onDrop={props.onDrop} onDragOver={props.onDragOver} />}
      <div ref={props.headerRef} className={clsx("mp-query-entry-section-header", {
      'is-empty': props.numEntries === 0,
      'is-sticky': props.isStickyHeader
    })}>
        {props.disableAddEntry ? <div className='mp-query-entry-section-header-label'>{props.label}</div> : singleEntryType ? <ButtonReact className={clsx("new-entry-button", {
        'is-open': props.isTypeSelectOpen
      })} disabled={isAddingDisabled} theme={ButtonTheme.QueryBuilder} elref='newEntryButton' pressed={props.draggingOverStepIndex === 0 && props.canDrop} tooltip={props.tooltipAttrs} size={ButtonSize.Large} experimentalPositioning onClick={() => props.onClickAdd(singleEntryType)}>
            {props.label}
            <div className='mp-query-entry-section-query-header-settings'>
              {isAddingSupported && <SvgIconReact icon='plus' />}
            </div>
          </ButtonReact> : <SelectReact className={clsx("type-select", {
        'is-open': props.isTypeSelectOpen
      })} elref='typeSelect' disabled={isSelectDisabled} alwaysShowCaret icon={{
        leftIcon: "",
        rightIcon: "plus"
      }} menuWidth={props.addEntryMenuWidth} menuAlignment={Directions.Right} sections={sections} theme={SelectTheme.Tertiary} tooltip={props.tooltipAttrs} label={t("query-builder.metric", {
        count: 2
      })} experimentalPositioning onChange={(ev: CustomEvent) => !props.isSelectDisabled && props.onClickAdd(ev.detail.item.value, true)} onMenuChange={props.onAddTypeSelectMenuChange} />}
        {props.headerItems}
      </div>
    </>;
}